import { CaseManagementDtoCaseConcluded, CaseManagementDtoCaseStatusValues, CaseManagementDtoComplexCaseStatus, CaseManagementDtoContactTracingType } from '../api/generated/model';

export function getComplexCaseStatusName(status: CaseManagementDtoComplexCaseStatus) {
  switch (status) {
    case CaseManagementDtoComplexCaseStatus.COMPLEX:
      return 'Ja';
    case CaseManagementDtoComplexCaseStatus.NOT_COMPLEX:
      return 'Nein';
    case CaseManagementDtoComplexCaseStatus.UNKNOWN:
      return 'Unbekannt';
  }
}

export function getCaseManagementStatusName(status: CaseManagementDtoCaseStatusValues | CaseManagementDtoContactTracingType) {
  switch (status) {
    case CaseManagementDtoCaseStatusValues.YES:
      return 'Ja';
    case CaseManagementDtoCaseStatusValues.NO:
      return 'Nein';
    case CaseManagementDtoCaseStatusValues.UNKNOWN:
      return 'Unbekannt';
    case CaseManagementDtoCaseStatusValues.COMPLETED:
      return 'Abgeschlossen';
    case CaseManagementDtoContactTracingType.ZENTRIFUGAL:
      return 'Zentrifugal';
    case CaseManagementDtoContactTracingType.ZENTRIPETAL:
      return 'Zentripetal';
  }
}
